<template>
  <div class="animated fadeIn">
    <b-card v-show="showList">
      <div slot="header">{{ this.$route.meta.title }}
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <button class="btn btn-primary mr-1" @click="close()"> <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row>
        <b-col lg="3">
          <b-input-group>
            <b-input-group-prepend><span class="pt-2 mr-2">Search VA</span></b-input-group-prepend>
            <b-form-input v-model="filter.search_text"></b-form-input>
          </b-input-group>
        </b-col>
        <b-col lg="3">
          <b-input-group>
            <b-input-group-prepend><span class="pt-2 mr-2">Project Type</span></b-input-group-prepend>
            <b-form-select v-model="filter.pjxkey" :plain="true" :options="filtertypes"></b-form-select>
          </b-input-group>
        </b-col>
        <b-col md="5">
          <b-row>
            <b-button class="btn btn-success ml-3 mr-1" @click="refresh()"> <i class="fa fa-refresh"></i> Apply
              Filter</b-button>
            <b-button class="btn btn-secondary mr-1" @click="clearFilter()"> <i class="fa fa-eraser"></i>Clear
              Filter</b-button>
          </b-row>
        </b-col>

      </b-row>

      <b-table class="mb-0" ref="table" outlined responsive hover small style="font-size:smaller;" :items="data"
        :fields="tblFields" :current-page="tblData.page" :per-page="tblData.limit" :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc" @row-clicked="rowClicked" :key="tblData.limit" show-empty>
        <template #thead-top="data">
        <b-tr>
          <b-th colspan="10"><div class="text-center">VA Information</div></b-th>
          <b-th variant="primary" colspan="3">Last Payment</b-th>
          <!-- <b-th variant="secondary">Type 1</b-th>
          <b-th variant="primary" colspan="3">Type 2</b-th>
          <b-th variant="danger">Type 3</b-th> -->
        </b-tr>
      </template>
        
        
        <template v-slot:cell(empty)="data">
          <h4>{{ data.emptyText }}</h4>
        </template>
        <template v-slot:cell(emptyfiltered)="data">
          <h4>{{ data.emptyFilteredText }}</h4>
        </template>



        <template v-slot:cell(billing_type)="data">
          <span>{{ billingTypeCase(data.item.billing_type) }}</span>
        </template>
        <template v-slot:cell(trx_amount)="data">
          <span>{{ data.item.trx_amount | numFormat('0,0.00') }}</span>
        </template>
        <template v-slot:cell(created_at)="data">
          <span>{{ data.item.created_at | moment('DD-MMM-YYYY HH:mm') }}</span>
        </template>

        <template v-slot:cell(datetime_expired)="data">
          <span>{{ data.item.datetime_expired | moment('DD-MMM-YYYY HH:mm:ss') }}</span>
        </template>

        <template v-slot:cell(datetime_payment)="data">
          <span>{{ data.item.datetime_payment | moment('DD-MMM-YYYY HH:mm:ss') }}</span>
        </template>
        <template v-slot:cell(payment_amount)="data">
          <span>{{ data.item.payment_amount | numFormat('0,0.00') }}</span>
        </template>
        <template v-slot:cell(cumulative_payment_amount)="data">
          <span>{{ data.item.cumulative_payment_amount | numFormat('0,0.00') }}</span>
        </template>


        <template v-slot:cell(action)="data">
          <div class="text-center">
            <a href="javascript:void(0)" v-b-tooltip.hover title="Edit" @click.stop="edit(data.item)">
              <i class="fa fa-pencil"></i>
            </a>
            |
            <a href="javascript:void(0)" class="text-success" v-b-tooltip.hover title="Inquiry"
              @click.stop="inquiry(data.item)">
              <i class="fa fa-search"></i>
            </a>
          </div>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{ (tblData.page - 1) * tblData.limit + 1 }}
            to <span v-if="((tblData.page * tblData.limit) > tblData.total)">{{ tblData.total }}</span> <span v-else>{{
      tblData.page * tblData.limit }}</span>
            of {{ tblData.total }} entries
          </div>
        </b-col>
        <b-col cols="4">
          <b-input-group>
            <b-input-group-prepend><span class="pt-1 mr-2">Limit per page</span></b-input-group-prepend>
            <b-form-select :options="[10, 15, 20, 25, 30, 35, 40, 45, 50]" :plain="true" v-model="tblData.limit"
              size="sm" style="max-width:80px;" />
          </b-input-group>
        </b-col>
        <b-col cols="4">
          <b-pagination align="right" :total-rows="tblData.total" :per-page="tblData.limit"
            v-model="tblData.page"></b-pagination>
        </b-col>
      </b-row>

      <!-- <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal> -->
    </b-card>
    <b-row class="justify-content-center" v-if="showForm">
      <b-col md="7" lg="6">
        <b-card>
          <div slot="header">Virtual Account - Add/Edit Form
          </div>
          <b-input-group>
            <b-input-group-prepend><label>Finance Account</label></b-input-group-prepend>
            <b-form-input readonly v-model="frmdata.namabank"
              @keyup.13.native="lkuBankaccountShow = true"></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" @click="lkuBankaccountShow = true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend><label>Trx. Id</label></b-input-group-prepend>
            <div v-if="(this.disableInput)" class="form-control-static">{{ frmdata.trx_id }}</div>
            <b-form-input v-else v-model="frmdata.trx_id" placeholder="Generate By System"></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend><label>Customer Name</label></b-input-group-prepend>
            <div v-if="(this.disableInput)" class="form-control-static">{{ frmdata.customer_name }}</div>
            <b-form-input v-else v-model="frmdata.customer_name"
              :state="!$v.frmdata.customer_name.$error"></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend><label>Customer Email</label></b-input-group-prepend>
            <div v-if="(this.disableInput)" class="form-control-static">{{ frmdata.customer_email }}</div>
            <b-form-input v-else v-model="frmdata.customer_email"
              :state="!$v.frmdata.customer_email.$error"></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend><label>Customer Phone</label></b-input-group-prepend>
            <div v-if="(this.disableInput)" class="form-control-static">{{ frmdata.customer_phone }}</div>
            <b-form-input v-else v-model="frmdata.customer_phone"
              :state="!$v.frmdata.customer_phone.$error"></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend><label>Billing Type</label></b-input-group-prepend>
            <b-form-select v-model="frmdata.billing_type" :plain="true" :options="billingTypeOpt"
              :state="!$v.frmdata.billing_type.$error"></b-form-select>
          </b-input-group>
          <b-input-group>
            <div class="form-control-static" style="margin-left:151px;">{{ frmdata.billing_type_desc }}</div>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend><label>Trx. Amount</label></b-input-group-prepend>
            <my-number class="form-control text-right" v-model="frmdata.trx_amount" :precision="0"
              :state="!$v.frmdata.trx_amount.$error"></my-number>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend><label>Virtual Account</label></b-input-group-prepend>
            <b-form-input v-model="frmdata.virtual_account" :state="!$v.frmdata.virtual_account.$error"></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend><label>Datetime Expired</label></b-input-group-prepend>
            <date-picker v-model="frmdata.datetime_expired" type="datetime"
              :state="!$v.frmdata.datetime_expired.$error"></date-picker>

          </b-input-group>
          <b-input-group>
            <b-input-group-prepend><label>Description</label></b-input-group-prepend>
            <b-form-input v-model="frmdata.description"></b-form-input>
          </b-input-group>

          <div slot="footer" style="text-align:center;">
            <button class="btn btn-primary mr-1" @click="save()">
              <i class="fa fa-save"></i> Save
            </button>
            <b-button variant="secondary" class="mr-1" @click="closeFrm()"> <i class="fa fa-close"></i> Close
              Form</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-modal v-model="lkuBankaccountShow" size="lg" :hide-footer="true" title="List of Bank/Cash Account"
      :centered="true">
      <lku-bankaccount @click="onSelectLkuBankaccount" :isbank="1"  :isVAAccount="1"></lku-bankaccount>
    </b-modal>
  </div>
</template>

<style lang="scss">
.input-group {
  padding-bottom: 2px;

  .input-group-prepend {
    label {
      padding-top: 5px;
      padding-right: 5px;
      width: 100px;
    }
  }
}
</style>


<script>
import toastr from "mini-toastr";
import crud from "../../apis/crud";
import ecollection from "../../apis/ecollection"
import lkuBankaccount from "../lookup/lkuBankaccount";
import myNumber from "../../components/my-number.vue";
import moment from "moment"
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

import datePicker from 'vue-bootstrap-datetimepicker';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';


export default {
  components: { lkuBankaccount, datePicker, myNumber },
  mixins: [validationMixin],
  validations: {
    frmdata: {
      // nasabahkey: {
      //   required: requiredIf(function () {
      //     return this.disableInput
      //   })
      // },
      // pinjamankey: {
      //   required: requiredIf(function () {
      //     return this.disableInput
      //   })
      // },
      customer_name: { required },
      customer_email: { required },
      customer_phone: { required },
      trx_amount: { required },
      billing_type: { required },
      virtual_account: { required },
      datetime_expired: { required },
    },
  },
  data() {
    return {
      showDelConfirm: false,
      showList: true,
      showForm: false,
      lkuCustomerShow: false,
      bankOnly: 1,
      lkuBankaccountShow: false,
      frmdata: {
        trx_id: '',
        trx_amount: 0,
        billing_type: 'n',
        billing_type_desc: '',
        customer_name: '',
        customer_email: '',
        customer_phone: '',
        virtual_account: '',
        datetime_expired: moment().add(1, 'month').format('DD/MM/YYYY HH:mm'),
        description: '',
        nasabahkey: '',
        pinjamankey: '',
        pjxkey: '',
        kodebank:'',
        namabank:''
      },
      types: [],
       filtertypes: [{ value: '', text: '--ALL--' }],
      studiolives: [], studiotapes: [], spotrates: [],
      tblData: {
        tablename: 'e-collection',
        page: 1,
        limit: 15,
        total: 0,
        sortBy: 'created_at',
        sortDesc: true,
      },
      billingTypeOpt: [
        { value: 'o', text: '(o) Open payment', description: 'invoice/billing can be paid multiple times as long as it is still active' },
        {
          value: 'c', text: '(c)Fixed payment', description: 'invoice/billing should be paid with exactly the same amount as requested.'
        },
        { value: 'i', text: '(i) Installment/partial payment', description: 'nvoice/billing can be paid multiple times as long as paid amount is less than the requested amount and still active' },
        { value: 'm', text: '(m) Minimum payment', description: 'invoice/billing can be paid with greater than or equal to the requested amount.' },
        { value: 'n', text: '(n) Open minimum payment', description: 'invoice/billing can be paid greater than or equal to the requested amount multiple times as long as it is still active.' },
        { value: 'x', text: '(x) Open maximum payment', description: 'invoice/billing can be paid less than or equal to the requested amount multiple times as long as it is still active.' },
      ],
      filter: { pjxkey: '',search_text:'' }
    };
  },
  computed: {
    tblFields() {
      const fields = [
        {
          key: "trx_id",
          label: "Billing ID",
          thClass: "text-center",
          sortable: true
        },
        {
          key: "client_id",
          label: "Client Id",
          thClass: "text-center",
          sortable: true
        },
        {
          key: "billing_type",
          label: "Billing Type",
          thClass: "text-center",
          sortable: true
        },
        {
          key: "customer_name",
          label: "Customer Name",
          thClass: "text-center",
          sortable: true
        },
        {
          key: "virtual_account",
          label: "VA Number",
          thClass: "text-center",
          sortable: true
        },
        {
          key: "trx_amount",
          label: "Billing Amount",
          tdClass: "text-right",
          thClass: "text-center",
          sortable: true
        },
        {
          key: "description",
          label: "Description",
          thClass: "text-center",
          sortable: true
        },
        {
          key: "created_by",
          label: "Created By",
          thClass: "text-center",
          sortable: true
        },
        {
          key: "created_at",
          label: "Created At",
          thClass: "text-center",
          sortable: true
        },
        {
          key: "datetime_expired",
          label: "Expired At",
          thClass: "text-center",
          sortable: true
        },
        {
          key: "datetime_payment",
          label: "Datetime Payment",
          thClass: "text-center",
          sortable: true
        },
        {
          key: "payment_amount",
          label: "Payment Amt.",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true
        },
        {
          key: "cumulative_payment_amount",
          label: "Cumulative Payment",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true
        },

        {
          key: "action",
          label: "Action",
          thClass: "text-center",
          sortable: true
        },
      ];
      return fields;
    },
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
    disableInput() {
      return Object.keys(this.$route.params).length > 0
    },
  },
  watch: {
    'frmdata.billing_type'(val) {
      let obj = this.billingTypeOpt.find(x => x.value == val)
      this.frmdata.billing_type_desc = obj.description
    }
  },
  created: async function () {
    const [a] = await Promise.all([
      crud.list({
        tablename: 'project',
        page: 1,
        limit: 1000,
        total: 0,
        sortBy: null,
        sortDesc: true
      })
    ]);
    this.filtertypes = a.reduce((newArr=[{ value: '',text:'-- ALL --'}], item) => {
      newArr.push({ value: item.pjxkey, text: `${item.pjxcode} - ${item.pjxname}` });
      return newArr;
    }, [{ value: '',text:'-- ALL --'}]);

    if (this.$route.name == "loan.ecollectiontransactions") {
      const { model, showForm, showList } = this.$route.params
      if (model) {
        this.showForm = showForm
        this.showList = showList
        this.frmdata.nasabahkey = model.nasabahkey;
        this.frmdata.pinjamankey = model.pinjamankey;
        this.frmdata.pjxkey = model.pjxkey;
        this.frmdata.customer_name = model.CustName;
        this.frmdata.customer_email = model.email;
        this.frmdata.customer_phone = model.nohandphone;
        this.frmdata.virtual_account = model.vanumber
      }

    }
  },
  methods: {
    onSelectLkuBankaccount(_selected) {
      this.frmdata.kodebank = _selected.kode;
      this.frmdata.namabank = _selected.namabank;
      this.frmdata.virtual_account = `${_selected.va_prefix}${_selected.va_client_id}`
      this.lkuBankaccountShow = false;
    },
    billingTypeCase(expression) {
      let text = ''
      switch (expression) {
        case 'o':
          text = 'Open Payment (o)'
          break;
        case 'c':
          text = 'Fixed payment (c)'
          break;
        case 'i':
          text = 'Installment/Partial Payment (i)'
          break;
        case 'm':
          text = 'Minimum Payment (m)'
          break;
        case 'n':
          text = 'Open Minimum Payment (n)'
          break;
        default:
          text = 'Open Maximum Payment (x)'
        // code block
      }

      return text;
    },
    data: async function (ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.tblData.customQuery = '';
      let str = '';
      if (this.filter.pjxkey) {
        str = 'pjxkey=%' + encodeURIComponent(this.filter.pjxkey) + '%';
      }
      if (this.filter.search_text) {
        // str += str ? '&' : '';
        // str = str + 'trx_id=' + encodeURIComponent(this.filter.search_text);

        // str += str ? '&' : '';
        // str = str + 'customer_name=' + encodeURIComponent(this.filter.search_text);

        str += str ? '&' : '';
        str = str + 'virtual_account=' + encodeURIComponent(this.filter.search_text);
      }
      
      this.tblData.customQuery = str;
      const list = await crud.list(this.tblData);
      return list;
    },
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    clearFilter(ctx) {
      this.filter.pjxname = '';
      this.filter.pjxjobtype = '';
      this.refresh();
    },
   
    add: function (data) {
      for (var key in this.frmdata) {
        this.frmdata[key] = '';
      }
      this.frmdata.billing_type = 'n'
      this.frmdata.datetime_expired = moment().add(1, 'month')
      this.showForm = true;
      this.showList = false;
    },
    edit: async function (data) {
      this.model = data;
      for (var key in this.frmdata) {
        this.frmdata[key] = '';
      }
      for (var key in this.model) {
        this.frmdata[key] = this.model[key];
      }
      this.frmdata.datetime_expired = new Date(data.datetime_expired)
      this.showForm = true;
      this.showList = false;

    },
    save: async function (callback) {
      if (this.invalidFormdata) {
        console.log('validation : ', this.$v.frmdata);
        console.log('frmdata : ', this.frmdata);
        toastr.error('Please fill the form correctly.', 'ERROR MESSAGE');
      } else {
        try {
          const { data } = await ecollection.save(this.frmdata)
          if (data.status == '000') {
            toastr.success(data.message);
            this.closeFrm()
          } else {
            toastr.error(data.message);
          }

        } catch (error) {
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    inquiry: async function (obj) {
      try {
        const { data } = await ecollection.inqury(obj)
        if (data.status == '000') {
          toastr.success(data.message);
        } else {
          toastr.error(data.message);
        }
      } catch (error) {

      }
    },
    // deleteConfirm(item) {
    //   this.model = item;
    //   this.showDelConfirm = true;
    // },
    // deleteData: async function () {
    //   await crud.remove({ tablename: 'project', key: this.model.pjxkey });
    //   this.refresh();
    // },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
        delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant = 'info';
      this.$forceUpdate();
    },
    closeFrm() {
      this.showForm = false;
      this.showList = true;
    },
    close() {
      router.push("home");
    },
  }
};
</script>
